type CheckboxProps = {
  name: string;
  label?: string | JSX.Element;
  defaultChecked?: boolean;
  required?: boolean;
  error?: string;
};

export default function Checkbox({
  name,
  label,
  defaultChecked,
  required,
  error,
}: CheckboxProps) {
  return (
    <div>
      <div className="flex gap-2">
        <input
          id={name}
          name={name}
          type="checkbox"
          value="true"
          required={required}
          defaultChecked={defaultChecked}
          className="h-4 w-4 flex-none rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        />
        {label && (
          <label htmlFor={name} className="text-sm text-gray-900">
            {label}
          </label>
        )}
      </div>
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
    </div>
  );
}
